import { CustomerSite } from "@hydrologiq/gql-experience/graphql"
import RunDry from "../generic/RunDry"
import { Customer } from "@hydrologiq/gql-experience/graphql"

const CustomerRunDry = ({
  context,
  loading,
  error,
}: {
  context?: Customer | CustomerSite
  loading?: boolean
  error?: string | undefined
}) => {
  console.log("context", context)
  // Use the new earliest_run_dry data from customer_list_view
  const earliestRunDryMinutes =
    typeof context === "object" && "earliestRunDryMinutes" in context
      ? context.earliestRunDryMinutes
      : (context as Customer)?.earliestRunDryMinutes
  const earliestRunDrySite =
    typeof context === "object" && "location" in context
      ? (context as CustomerSite).location
      : (context as Customer)?.earliestRunDrySite

  // Convert minutes to hours
  const days = earliestRunDryMinutes ? Math.round((earliestRunDryMinutes / 60 / 24) * 100) / 100 : undefined

  return (
    <RunDry
      heading={"Run dry"}
      hours={days}
      loading={loading}
      error={error}
      isPlaceholder={!earliestRunDryMinutes}
      location={earliestRunDrySite?.name ?? undefined}
      granularity="days"
      customer={context?.id ?? undefined}
      site={earliestRunDrySite?.id ?? undefined}
    />
  )
}

export default CustomerRunDry
